module.exports = __webpack_public_path__ + "media/packs/images/flags/KM-c2ff861db38f0bc660965d531b30a56d.svg";